import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Non_mover",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	enableBackground: "new 0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Reload" }),
		/* @__PURE__ */ _jsx("polygon", { points: "7,16 11,16 16,11 11,6 7,6 12,11 " }),
		/* @__PURE__ */ _jsx("path", { d: "M6.3,0L16,0v3H6.3C4.5,3,3,4.5,3,6.2s1.5,3.2,3.3,3.2h7.2v3H6.3C2.9,12.4,0,9.6,0,6.2S2.8,0,6.3,0z" })
	]
});
export default SvgReload;
